import { EnumColorName } from '@libs/constants';

import { EnumMbaColor, EnumMbaFitType, EnumMbaMarketplace, EnumMbaPrint, EnumMbaProduct, EnumMbaProductType, EnumMbaScalingType } from './mba-amazon.constants';


/**------------------------------------------------------
 * MBA Products Configurations
 * ---------------------------
 * > Amazon Royalties: https://merch.amazon.com/resource/201858580?language=en_US
 * > Linear Curve Fit: https://www.wolframalpha.com/input?i=linear+fit+%7B%7B13.38%2C+0%7D%2C+%7B35.00%2C+15.99%7D%7D
 */
export const MBA_PRODUCT_SPECIFICATION: IAmazonMbaProduct[] = [

	// Standard t-shirt --------------------
	{
		code			: EnumMbaProduct.StandardShirt,
		name			: 'Standard T-Shirt',
		nameShort		: 'Standard T-Shirt',
		chartColor		: EnumColorName.Darkgray,
		oldCode			: 'Standard t-shirt',
		productorCode	: 'STANDARD_TSHIRT',
		keywords		: [
			'standard_shirt', 'standard t-shirt', 'standard shirt', 'standard_shirt',
			'standard_shirts', 'standard t-shirts', 'standard shirts', 'standard_shirts',
			'standard_tshirt', 'shirt', 't-shirt', 't shirt'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.38,
				getRoyalty	: (price: number) => 0.739593 * price - 9.89575			// linear fit {{13.38, 0}, {35.00, 15.99}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.08,
				getRoyalty	: (price: number) => 0.660714 * price - 7.98143			// linear fit {{12.07, 0}, {30, 11.84}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.71,
				getRoyalty	: (price: number) => 0.63054 * price - 8.64201			// linear fit {{13.71, 0}, {15.66, 1.23}, {19.99, 3.96}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.75,
				getRoyalty	: (price: number) => 0.655385 * price - 9.01154			// linear fit {{13.75, 0}, {30, 10.65}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.75,
				getRoyalty	: (price: number) => 0.643692 * price - 8.85077 		// linear fit {{13.75, 0}, {30, 10.46}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.31,
				getRoyalty	: (price: number) => 0.6429 * price - 8.557 			// linear fit {{13.31, 0}, {30, 10.73}}
			},
			{
				market		: EnumMbaMarketplace.JP,
				priceMin	: 1,
				priceMax	: 9999,
				priceDefault: 1615.3,
				getRoyalty	: (price: number) => Math.round(0.740271 * price - 1195.76) // linear fit {{1615.3, 0}, {6500, 3616}} // Note: Yen is rounding off the number
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women, EnumMbaFitType.Youth, EnumMbaFitType.Girls]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Asphalt, EnumMbaColor.BabyBlue, EnumMbaColor.Black, EnumMbaColor.Brown, EnumMbaColor.Cranberry,
				EnumMbaColor.DarkHeather, EnumMbaColor.Grass, EnumMbaColor.HeatherBlue, EnumMbaColor.HeatherGrey, EnumMbaColor.KellyGreen,
				EnumMbaColor.Lemon, EnumMbaColor.Navy, EnumMbaColor.Olive, EnumMbaColor.Orange, EnumMbaColor.Pink, EnumMbaColor.Purple,
				EnumMbaColor.Red, EnumMbaColor.Royal, EnumMbaColor.Silver, EnumMbaColor.Slate, EnumMbaColor.White, EnumMbaColor.DarkGreen,
				EnumMbaColor.Burgundy, EnumMbaColor.GoldenYellow, EnumMbaColor.PurpleHeather, EnumMbaColor.RedHeather, EnumMbaColor.OliveHeather,
				EnumMbaColor.PinkHeather, EnumMbaColor.Sapphire, EnumMbaColor.Ivory, EnumMbaColor.LightBeige, EnumMbaColor.LightPink,
				EnumMbaColor.LightPurple, EnumMbaColor.MintGreen
			],
			light 		:[
				EnumMbaColor.BabyBlue, EnumMbaColor.Grass, EnumMbaColor.HeatherGrey, EnumMbaColor.Lemon, EnumMbaColor.Orange,
				EnumMbaColor.Pink, EnumMbaColor.Red, EnumMbaColor.Silver, EnumMbaColor.Slate, EnumMbaColor.White, EnumMbaColor.GoldenYellow,
				EnumMbaColor.RedHeather, EnumMbaColor.OliveHeather, EnumMbaColor.PinkHeather, EnumMbaColor.Sapphire, EnumMbaColor.Ivory,
				EnumMbaColor.LightBeige, EnumMbaColor.LightPink, EnumMbaColor.LightPurple, EnumMbaColor.MintGreen
			],
			dark 		: [
				EnumMbaColor.Asphalt, EnumMbaColor.Black, EnumMbaColor.Brown, EnumMbaColor.Cranberry, EnumMbaColor.DarkHeather,
				EnumMbaColor.HeatherBlue, EnumMbaColor.KellyGreen, EnumMbaColor.Navy, EnumMbaColor.Olive,
				EnumMbaColor.Royal, EnumMbaColor.Purple, EnumMbaColor.DarkGreen, EnumMbaColor.Burgundy, EnumMbaColor.PurpleHeather
			],
			background	: false
		}
	},

	// Value graphic t-shirt --------------------
	{
		code			: EnumMbaProduct.ValueGraphicTShirt,
		name			: 'Value Graphic T-Shirt',
		nameShort		: 'Value Graphic T-Shirt',
		chartColor		: EnumColorName.Darkgray,
		oldCode			: 'Value Graphic T-shirt',
		productorCode	: 'VALUE_GRAPHIC_TSHIRT',
		keywords		: [
			'value_graphic_tshirt', 'value graphic t-shirt', 'value graphic shirt', 'value_graphic_shirt',
			'value_graphic_tshirts', 'value graphic t-shirts', 'value graphic shirts', 'value_graphic_shirts'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.99,
				getRoyalty	: (price: number) => (0.83 * price) - 9.7817 // linear fit {{12.99, 1.00}, {13.99, 1.83}, {14.99, 2.66}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.99,
				getRoyalty	: (price: number) => (0.84 * price) - 9.8216 // linear fit {{12.99, 1.09}, {13.99, 1.93}, {14.99, 2.77}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.99,
				getRoyalty	: (price: number) => (0.83 * price) - 9.7817 // linear fit {{12.99, 1.00}, {13.99, 1.83}, {14.99, 2.66}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.99,
				getRoyalty	: (price: number) => (price <= 13.99 ? (0.64 * price) - 7.3136 : (0.82 * price) - 9.8318) // piecewise linear fit {{12.99, 1.00}, {13.99, 1.64}, {14.99, 2.46}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.99,
				getRoyalty	: (price: number) => (price <= 13.99 ? (0.73 * price) - 8.4827 : (0.83 * price) - 9.8817) // piecewise linear fit {{12.99, 1.00}, {13.99, 1.73}, {14.99, 2.56}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.White
			],
			light 		:[
				EnumMbaColor.White
			],
			dark 		: [
				EnumMbaColor.Black
			],
			background	: false
		}
	},

	// Premium t-shirt ---------------------
	{
		code			: EnumMbaProduct.PremiumShirt,
		name			: 'Premium T-Shirt',
		nameShort		: 'Premium T-Shirt',
		chartColor		: EnumColorName.Gray,
		oldCode			: 'Premium t-shirt',
		productorCode	: 'PREMIUM_TSHIRT',
		keywords		: [
			'premium_shirt', 'premium t-shirt', 'premium shirt', 'premium_tshirt',
			'premium_shirts', 'premium t-shirts', 'premium shirts', 'premium_tshirts'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.05,
				getRoyalty	: (price: number) => (0.70 * price) - 10.273			// linear fit {{15.05, 0}, {45, 22.63}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty	: (price: number) => (0.70 * price) - 12.393			// linear fit {{22.99, 3.70}, {23.99, 4.40}, {24.99, 5.10}, {25.99, 5.80}, {26.99, 6.50}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty: (price: number) => (0.145 * price) - 0.041885			// linear fit {{18.99, 2.71}, {19.99, 2.86}, {20.99, 3.00}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty: (price: number) => (0.14 * price) + 0.0314				// linear fit {{18.99, 2.69}, {19.99, 2.83}, {20.99, 2.97}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty: (price: number) => (0.135 * price) + 0.08801667			// linear fit {{18.99, 2.65}, {19.99, 2.79}, {20.99, 2.92}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty: (price: number) => (0.14 * price) + 0.0114				// linear fit {{18.99, 2.67}, {19.99, 2.81}, {20.99, 2.95}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Olive, EnumMbaColor.Slate, EnumMbaColor.Brown, EnumMbaColor.Beige, EnumMbaColor.Burgundy, EnumMbaColor.Grey,
				EnumMbaColor.Mauve, EnumMbaColor.Storm, EnumMbaColor.Tan, EnumMbaColor.Forest
			],
			light 		:[
				EnumMbaColor.Beige, EnumMbaColor.Grey, EnumMbaColor.Mauve, EnumMbaColor.Storm, EnumMbaColor.Tan, EnumMbaColor.Forest
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Olive, EnumMbaColor.Slate, EnumMbaColor.Brown, EnumMbaColor.Burgundy
			],
			background	: false
		}
	},

	// Comfort colors heavyweight t-shirt
	{
		code			: EnumMbaProduct.ComfortColorsHeavyweightTShirt,
		name			: 'Comfort Colors Heavyweight T-Shirt',
		nameShort		: 'Heavyweight T-Shirt',
		chartColor		: EnumColorName.Darkgray,
		oldCode			: 'Comfort Colors heavyweight t-shirt',
		productorCode	: 'COMFORT_COLORS_HEAVYWEIGHT_TSHIRT',
		keywords		: [
			'comfort_colors_heavyweight_tshirt', 'comfort colors heavy weight t-shirt', 'comfort colors heavyweight t-shirt',
			'comfort colors heavy weight t-shirts', 'comfort colors heavyweight t-shirts'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 21.99,
				getRoyalty  : (price: number) => (0.70 * price) - 12.393 // linear fit from {19.99,1.60}–{24.99,5.10}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 17.99,
				getRoyalty	: (price: number) => (0.70 * price) - 12.393	 		// linear fit {{22.99, 3.70}, {23.99, 4.40}, {24.99, 5.10}, {25.99, 5.80}, {26.99, 6.50}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty: (price: number) => (0.145 * price) - 0.041885			// linear fit {{18.99, 2.71}, {19.99, 2.86}, {20.99, 3.00}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty: (price: number) => (0.14 * price) + 0.0314				// linear fit {{18.99, 2.69}, {19.99, 2.83}, {20.99, 2.97}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty: (price: number) => (0.135 * price) + 0.08801667			// linear fit {{18.99, 2.65}, {19.99, 2.79}, {20.99, 2.92}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty: (price: number) => (0.14 * price) + 0.0114				// linear fit {{18.99, 2.67}, {19.99, 2.81}, {20.99, 2.95}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.White, EnumMbaColor.DeepBlue, EnumMbaColor.Plum, EnumMbaColor.PurpleTieDye,
				EnumMbaColor.GreyTieDye, EnumMbaColor.DarkGrey, EnumMbaColor.RaspberryRed, EnumMbaColor.Pink,
				EnumMbaColor.Beige, EnumMbaColor.BlueTieDye, EnumMbaColor.FernTieDye, EnumMbaColor.UmberTieDye
			],
			light 		: [
				EnumMbaColor.White, EnumMbaColor.PurpleTieDye, EnumMbaColor.GreyTieDye, EnumMbaColor.Pink,
				EnumMbaColor.Beige, EnumMbaColor.BlueTieDye, EnumMbaColor.FernTieDye, EnumMbaColor.UmberTieDye
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.DeepBlue, EnumMbaColor.Plum, EnumMbaColor.DarkGrey, EnumMbaColor.RaspberryRed
			],
			background	: false
		}
	},

	// V-neck t-shirt ----------------------
	{
		code			: EnumMbaProduct.VNeckShirt,
		name			: 'V-Neck T-Shirt',
		nameShort		: 'V-Neck T-Shirt',
		chartColor		: EnumColorName.Lightgray,
		oldCode			: 'V-neck t-shirt',
		productorCode	: 'VNECK',
		keywords		: [
			'vneck_shirt', 'v-neck t-shirt', 'vneck', 'vneck shirt',
			'vneck_shirts', 'v-neck t-shirts', 'vnecks', 'vneck shirts'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.18,
				getRoyalty	: (price: number) => (0.74773 * price) - 11.3505 		// linear fit {{15.18, 0}, {35, 14.82}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.91,
				getRoyalty	: (price: number) => (0.650068 * price) - 8.39238 		// linear fit {{12.91, 0}, {35, 14.36}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.54,
				getRoyalty	: (price: number) => (0.621622 * price) - 8.41676 		// linear fit {{13.54, 0}, {35, 13.34}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 14.51,
				getRoyalty	: (price: number) => (0.645681 * price) - 9.36883 		// linear fit {{14.51, 0}, {35, 13.23}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 14.49,
				getRoyalty	: (price: number) => (0.63335 * price) - 9.17724 		// linear fit {{14.49, 0}, {35, 12.99}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 14.05,
				getRoyalty	: (price: number) =>  (0.630072 * price) - 8.85251 		// linear fit {{14.05, 0}, {35, 13.20}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.BabyBlue, EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.ForestGreen, EnumMbaColor.HeatherGrey,
				EnumMbaColor.Navy, EnumMbaColor.Pink, EnumMbaColor.Purple, EnumMbaColor.Red, EnumMbaColor.Sapphire
			],
			light 		:[
				EnumMbaColor.BabyBlue, EnumMbaColor.HeatherGrey, EnumMbaColor.Pink, EnumMbaColor.Red, EnumMbaColor.Sapphire
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.ForestGreen, EnumMbaColor.Navy, EnumMbaColor.Purple, EnumMbaColor.Red, EnumMbaColor.Sapphire
			],
			background	: false
		}
	},

	// Tank top ----------------------------
	{
		code			: EnumMbaProduct.TankTop,
		name			: 'Tank Top',
		nameShort		: 'Tank Top',
		chartColor		: EnumColorName.Royalblue,
		oldCode			: 'Tank top',
		productorCode	: 'TANK_TOP',
		keywords		: [
			'tank_top', 'tank_top', 'tank top', 'tanktop',
			'tank_tops', 'tank_tops', 'tank tops', 'tanktops'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.27,
				getRoyalty	: (price: number) => (0.762798 * price) - 11.6479 		// linear fit {{15.27, 0}, {35, 15.05}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.38,
				getRoyalty	: (price: number) => (0.631167 * price) - 8.44502 		// linear fit {{13.38, 0}, {30, 10.49}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 14.23,
				getRoyalty	: (price: number) => (0.604312 * price) - 8.59936 		// linear fit {{14.23, 0}, {30, 9.53}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.83,
				getRoyalty	: (price: number) => (0.674088 * price) - 9.32263 		// linear fit {{13.83, 0}, {30, 10.90}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.83,
				getRoyalty	: (price: number) => (0.661719 * price) - 9.15158 		// linear fit {{13.83, 0}, {30, 10.70}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.73,
				getRoyalty	: (price: number) => (0.645974 * price) - 8.86923 		// linear fit {{13.73, 0}, {30, 10.51}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.HeatherGrey, EnumMbaColor.Navy, EnumMbaColor.NeonPink,
				EnumMbaColor.Purple, EnumMbaColor.Red, EnumMbaColor.Royal, EnumMbaColor.Sapphire, EnumMbaColor.White, EnumMbaColor.Pink
			],
			light 		:[
				EnumMbaColor.HeatherGrey, EnumMbaColor.NeonPink, EnumMbaColor.Red, EnumMbaColor.Sapphire, EnumMbaColor.White, EnumMbaColor.Pink
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.Navy, EnumMbaColor.Red, EnumMbaColor.Royal,
				EnumMbaColor.Purple, EnumMbaColor.Sapphire
			],
			background	: false
		}
	},

	// Performance shirt -------------------
	{
		code			: EnumMbaProduct.PerformanceShirt,
		name			: 'Performance T-Shirt',
		nameShort		: 'Performance T-Shirt',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Performance T-Shirt',
		productorCode	: 'PERFORMANCE_T_SHIRT',
		keywords		: [
			'performance_shirt', 'performance t-shirt', 't-shirt', 'performance', 'tshirt',
			't-shirts', 'tshirts', 'tee', 'teeshirt', 'tees'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 17.99,
				getRoyalty: (price: number): number => (0.70 * price) - 9.793  // fit from {14.99,0.70}–{15.99,1.40}–{16.99,2.10}
			},
			{
				market		: EnumMbaMarketplace.JP,
				priceMin	: 1,
				priceMax	: 9999,
				priceDefault: 2499,
				getRoyalty: (price: number): number => Math.round((0.318 * price) - 564.2) // fit from {1900,40}–{2000,72}–{2100,104}–{2200,135}–{2300,167}–{2400,199}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Youth]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.White, EnumMbaColor.SlateGrey, EnumMbaColor.RoyalBlue, EnumMbaColor.LightBlue, EnumMbaColor.NavyBlue, EnumMbaColor.AsphaltGrey, EnumMbaColor.Red
			],
			light 		: [
				EnumMbaColor.White, EnumMbaColor.SlateGrey, EnumMbaColor.RoyalBlue, EnumMbaColor.LightBlue
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.NavyBlue, EnumMbaColor.AsphaltGrey, EnumMbaColor.Red
			],
			background	: false
		}
	},

	// Long sleeve t-shirt -----------------
	{
		code			: EnumMbaProduct.LongSleeveShirt,
		name			: 'Long Sleeve T-Shirt',
		nameShort		: 'Long Sleeve',
		chartColor		: EnumColorName.Blue,
		oldCode			: 'Long sleeve t-shirt',
		productorCode	: 'STANDARD_LONG_SLEEVE',
		keywords		: [
			'long_sleeve_shirt', 'long sleeve t-shirt', 'sleeve t-shirt', 'long sleeve shirt',
			'long_sleeve_shirts', 'long sleeve t-shirts', 'sleeve t-shirts', 'long sleeve shirts',
			'long sleeve', 'standard_long_sleeve', 'sleeve shirt'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 17.68,
				getRoyalty	: (price: number) => (0.717294 * price) - 12.6818 				// linear fit {{17.68, 0}, {40, 16.01}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 16.51,
				getRoyalty	: (price: number) => (0.632774 * price) - 10.4471 				// linear fit {{16.51, 0}, {35, 11.70}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 17.78,
				getRoyalty	: (price: number) => (0.601045 * price) - 10.6866 				// linear fit {{17.78, 0}, {35, 10.35}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 16.19,
				getRoyalty	: (price: number) => (0.656566 * price) - 10.6298 				// linear fit {{16.19, 0}, {35, 12.35}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 16.20,
				getRoyalty	: (price: number) => (0.648319 * price) - 10.5028 				// linear fit {{16.20, 0}, {40, 15.43}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 16.02,
				getRoyalty	: (price: number) => (0.62427 * price) - 10.0008 				// linear fit {{16.02, 0}, {40, 14.97}}
			},
			{
				market		: EnumMbaMarketplace.JP,
				priceMin	: 1,
				priceMax	: 9999,
				priceDefault: 2148.6,
				getRoyalty	: (price: number) => Math.round((0.623478 * price) - 1339.6) 	// linear fit {{2148.6, 0}, {6500, 2713}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.HeatherGrey, EnumMbaColor.Navy, EnumMbaColor.Royal, EnumMbaColor.White],
			light 		: [
				EnumMbaColor.HeatherGrey, EnumMbaColor.White
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.Navy, EnumMbaColor.Royal
			],
			background	: false
		}
	},

	// Baseball Jersey -------------------------
	{
		code			: EnumMbaProduct.BaseballJersey,
		name			: 'Baseball Jersey',
		nameShort		: 'Baseball Jersey',
		chartColor		: EnumColorName.Red,
		oldCode			: 'Baseball Jersey',
		productorCode	: 'BASEBALL_JERSEY',
		keywords		: ['baseball_jersey', 'baseball jersey', 'baseball-jersey', 'baseballjersey'],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 29.99,
				getRoyalty: (price: number) => (0.7 * price) - 13.993 // linear fit {{29.99, 7.00}, {34.99, 10.50}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.FrontPrint,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.BackPrint,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Youth]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Slate, EnumMbaColor.White, EnumMbaColor.Red, EnumMbaColor.Royal, EnumMbaColor.LightBlue
			],
			light 		: [
				EnumMbaColor.White, EnumMbaColor.Red, EnumMbaColor.Royal, EnumMbaColor.LightBlue
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Slate
			],
			background	: false
		}
	},

	// Basketball Jersey -------------------------
	{
		code			: EnumMbaProduct.BasketballJersey,
		name			: 'Basketball Jersey',
		nameShort		: 'Basketball Jersey',
		chartColor		: EnumColorName.Orange,
		oldCode			: 'Basketball Jersey',
		productorCode	: 'BASKETBALL_JERSEY',
		keywords		: ['basketball_jersey', 'basketball jersey', 'basketball-jersey', 'basketballjersey'],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 24.99,
				getRoyalty: (price: number) => (0.7 * price) - 13.293 // linear fit {{24.99, 4.20}, {29.99, 7.70}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.FrontPrint,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.BackPrint,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women, EnumMbaFitType.Youth]
		},
		colors			: {
			all 		: [
				EnumMbaColor.BlackWhite, EnumMbaColor.NavyWhite, EnumMbaColor.SlateGreyWhite, EnumMbaColor.WhiteWhite, EnumMbaColor.RedWhite, EnumMbaColor.RoyalBlueWhite, EnumMbaColor.MaroonWhite
			],
			light 		: [
				EnumMbaColor.WhiteWhite, EnumMbaColor.RedWhite, EnumMbaColor.RoyalBlueWhite, EnumMbaColor.MaroonWhite
			],
			dark 		: [
				EnumMbaColor.BlackWhite, EnumMbaColor.NavyWhite, EnumMbaColor.SlateGreyWhite
			],
			background	: false
		}
	},

	// Soccer Jersey -------------------------
	{
		code			: EnumMbaProduct.SoccerJersey,
		name			: 'Soccer Jersey',
		nameShort		: 'Soccer Jersey',
		chartColor		: EnumColorName.Green,
		oldCode			: 'Soccer Jersey',
		productorCode	: 'SOCCER_JERSEY',
		keywords		: ['soccer_jersey', 'soccer jersey', 'soccer-jersey', 'soccerjersey'],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 29.99,
				getRoyalty: (price: number) => (0.7 * price) - 13.993 // linear fit {{29.99, 7.00}, {34.99, 10.50}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.FrontPrint,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.BackPrint,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.AdultUnisex, EnumMbaFitType.Youth]
		},
		colors			: {
			all 		: [
				EnumMbaColor.NavyWhite, EnumMbaColor.RoyalBlueWhite, EnumMbaColor.BlackWhite, EnumMbaColor.RedWhite, EnumMbaColor.DarkGreenWhite, EnumMbaColor.PurpleWhite, EnumMbaColor.SlateGreyWhite, EnumMbaColor.WhiteBlack, EnumMbaColor.WhiteWhite
			],
			light 		: [
				EnumMbaColor.WhiteBlack, EnumMbaColor.WhiteWhite, EnumMbaColor.RedWhite, EnumMbaColor.RoyalBlueWhite, EnumMbaColor.DarkGreenWhite, EnumMbaColor.PurpleWhite
			],
			dark 		: [
				EnumMbaColor.NavyWhite, EnumMbaColor.BlackWhite, EnumMbaColor.SlateGreyWhite
			],
			background	: false
		}
	},

	// Raglan ------------------------------
	{
		code			: EnumMbaProduct.Raglan,
		name			: 'Raglan',
		nameShort		: 'Raglan',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Raglan',
		productorCode	: 'RAGLAN',
		keywords		: ['raglan', 'raglans', 'raglan shirt', 'raglan_shirt', 'raglan-shirt'],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 23.99,
				getRoyalty	: (price: number) => (0.733936 * price) - 13.7771 				// linear fit {{23.99, 3.83}, {45, 19.25}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 17.99,
				getRoyalty	: (price: number) => (0.666112 * price) - 9.73335 				// linear fit {{17.99, 2.25}, {30, 10.25}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty	: (price: number) => (0.622918 * price) - 9.93213 				// linear fit {{19.99, 2.52}, {35, 11.87}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.635261 * price) - 10.7141 				// linear fit {{20.99, 2.62}, {35, 11.52}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.625268 * price) - 10.5444 				// linear fit {{20.99, 2.58}, {35, 11.34}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.610278 * price) - 10.2097 				// linear fit {{20.99, 2.60}, {35, 11.15}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.BlackAthleticHeather, EnumMbaColor.BlackWhite, EnumMbaColor.DarkHeatherWhite, EnumMbaColor.NavyAthleticHeather,
				EnumMbaColor.NavyWhite, EnumMbaColor.RedWhite, EnumMbaColor.RoyalBlueWhite
			],
			light 		: [
				EnumMbaColor.BlackAthleticHeather, EnumMbaColor.BlackWhite, EnumMbaColor.DarkHeatherWhite, EnumMbaColor.NavyAthleticHeather,
				EnumMbaColor.NavyWhite, EnumMbaColor.RedWhite, EnumMbaColor.RoyalBlueWhite
			],
			dark 		: [EnumMbaColor.BlackAthleticHeather, EnumMbaColor.NavyAthleticHeather],
			background	: false
		}
	},

	// Sweatshirt --------------------------
	{
		code			: EnumMbaProduct.Sweatshirt,
		name			: 'Sweatshirt',
		nameShort		: 'Sweatshirt',
		chartColor		: EnumColorName.Skyblue,
		oldCode			: 'Sweatshirt',
		productorCode	: 'STANDARD_SWEATSHIRT',
		keywords		: [
			'sweatshirt', 'standard_sweatshirt', 'standard sweatshirt',
			'sweatshirts', 'standard_sweatshirts', 'standard sweatshirts'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.15,
				getRoyalty	: (price: number) => (0.747202 * price) - 18.7921 				// linear fit {{25.15, 0}, {60, 26.04}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 23.99,
				getRoyalty	: (price: number) => (0.6297 * price) - 15.1065 				// linear fit {{23.99, 0}, {45, 13.23}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 26.31,
				getRoyalty	: (price: number) => (0.602786 * price) - 15.8593 				// linear fit {{26.31, 0}, {50, 14.28}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 22.98,
				getRoyalty	: (price: number) => (0.646188 * price) - 14.8494 				// linear fit {{22.98, 0}, {50, 17.46}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 23.35,
				getRoyalty	: (price: number) => (0.63227 * price) - 14.7635 				// linear fit {{23.35, 0}, {50, 16.85}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 23.29,
				getRoyalty	: (price: number) => (0.63085 * price) - 14.6925 				// linear fit {{23.29, 0}, {50, 16.85}}
			},
			{
				market		: EnumMbaMarketplace.JP,
				priceMin	: 1,
				priceMax	: 9999,
				priceDefault: 2975.6,
				getRoyalty	: (price: number) => Math.round((0.548523 * price) - 1632.19) 	// linear fit {{2975.6, 0}, {8000, 2756}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.AdultUnisex, EnumMbaFitType.Youth]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.HeatherGrey,
				EnumMbaColor.Navy, EnumMbaColor.Royal, EnumMbaColor.White, EnumMbaColor.Asphalt,
				EnumMbaColor.SageGreen, EnumMbaColor.Burgundy, EnumMbaColor.Red, EnumMbaColor.DustyBlue,
				EnumMbaColor.DarkGreen, EnumMbaColor.Purple, EnumMbaColor.Pink, EnumMbaColor.LightBlue,
				EnumMbaColor.BrightPink
			],
			light 		: [
				EnumMbaColor.HeatherGrey, EnumMbaColor.White, EnumMbaColor.SageGreen,
				EnumMbaColor.DustyBlue, EnumMbaColor.Pink, EnumMbaColor.LightBlue,
				EnumMbaColor.BrightPink
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.Navy,
				EnumMbaColor.Royal, EnumMbaColor.Asphalt, EnumMbaColor.Burgundy,
				EnumMbaColor.Red, EnumMbaColor.DarkGreen, EnumMbaColor.Purple
			],
			background	: false
		}
	},

	// Comfort colors sweatshirt ----------------
	{
		code			: EnumMbaProduct.ComfortColorsSweatshirt,
		name			: 'Comfort Colors Sweatshirt',
		nameShort		: 'Comfort Colors Sweatshirt',
		chartColor		: EnumColorName.Skyblue,
		oldCode			: 'Comfort Colors Sweatshirt',
		productorCode	: 'COMFORT_COLORS_SWEATSHIRT',
		keywords		: [
			'comfort_colors_sweatshirt', 'comfort colors sweatshirt',
			'comfort_colors_sweatshirts', 'comfort colors sweatshirts'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 39.99,
				getRoyalty: (price: number): number => (0.70 * price) - 24.603				// linear fit {{35.15, 0}, {39.99, 3.39}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [EnumMbaColor.Pepper, EnumMbaColor.BlueJean, EnumMbaColor.LightGreen, EnumMbaColor.Crimson, EnumMbaColor.Orchid, EnumMbaColor.Grey, EnumMbaColor.White, EnumMbaColor.Navy],
			light 		: [
				EnumMbaColor.LightGreen, EnumMbaColor.Grey, EnumMbaColor.White
			],
			dark 		: [
				EnumMbaColor.Pepper, EnumMbaColor.BlueJean, EnumMbaColor.Crimson, EnumMbaColor.Orchid, EnumMbaColor.Navy
			],
			background	: false
		}
	},

	// Comfort colors crop sweatshirt ----------------
	{
		code			: EnumMbaProduct.ComfortColorsCropSweatshirt,
		name			: 'Comfort Colors Crop Sweatshirt',
		nameShort		: 'Comfort Colors Crop Sweatshirt',
		chartColor		: EnumColorName.Skyblue,
		oldCode			: 'Comfort Colors Crop Sweatshirt',
		productorCode	: 'COMFORT_COLORS_CROP_SWEATSHIRT',
		keywords		: [
			'comfort_colors_crop_sweatshirt', 'comfort colors crop sweatshirt',
			'comfort_colors_crop_sweatshirts', 'comfort colors crop sweatshirts'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 39.99,
				getRoyalty: (price: number): number => (0.70 * price) - 24.603 // linear fit {{35.15, 0}, {37.99, 1.99}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [EnumMbaColor.Pepper, EnumMbaColor.Ivory, EnumMbaColor.Espresso, EnumMbaColor.BlueJean, EnumMbaColor.RoseQuartz, EnumMbaColor.Dusk],
			light 		: [
				EnumMbaColor.Ivory, EnumMbaColor.RoseQuartz, EnumMbaColor.Dusk
			],
			dark 		: [
				EnumMbaColor.Pepper, EnumMbaColor.Espresso, EnumMbaColor.BlueJean
			],
			background	: false
		}
	},

	// Crop top -------------------------------
	{
		code			: EnumMbaProduct.CropTop,
		name			: 'Crop Top',
		nameShort		: 'Crop Top',
		chartColor		: EnumColorName.Purple,
		oldCode			: 'Crop top',
		productorCode	: 'CROP_TOP',
		keywords		: [
			'crop_top', 'crop top', 'crop_top', 'croptop',
			'crop_tops', 'crop tops', 'crop_tops', 'croptops'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 21.99,
				getRoyalty: (price: number): number => (0.70 * price) - 11.553 // linear fit {{16.50, 0}, {21.99, 3.84}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.Pepper, EnumMbaColor.White, EnumMbaColor.Ivory, EnumMbaColor.Chambray,
				EnumMbaColor.RoseQuartz
			],
			light 		:[
				EnumMbaColor.White, EnumMbaColor.Ivory, EnumMbaColor.Chambray, EnumMbaColor.RoseQuartz
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.Pepper
			],
			background	: false
		}
	},

	// Pullover hoodie ---------------------
	{
		code			: EnumMbaProduct.PulloverHoodie,
		name			: 'Pullover Hoodie',
		nameShort		: 'Pullover Hoodie',
		chartColor		: EnumColorName.Orange,
		oldCode			: 'Pullover hoodie',
		productorCode	: 'STANDARD_PULLOVER_HOODIE',
		keywords		: [
			'pullover_hoodie', 'pullover hoodie', 'standard_pullover_hoodie', 'hoodie',
			'pullover_hoodies', 'pullover hoodies', 'standard_pullover_hoodies', 'hoodies'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.04,
				getRoyalty	: (price: number) => (0.72111 * price) - 18.0566 		// linear fit {{25.04, 0}, {60, 25.21}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.62,
				getRoyalty	: (price: number) => (0.640117 * price) - 16.405 		// linear fit {{25.62, 0}, {45.00, 12.40}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 28.65,
				getRoyalty	: (price: number) => (0.603714 * price) - 17.3004 		// linear fit {{28.65, 0}, {50, 12.90}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.52,
				getRoyalty	: (price: number) => (0.66009 * price) - 16.845 		// linear fit {{25.52, 0}, {50, 16.15}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.92,
				getRoyalty	: (price: number) => (0.645006 * price) - 16.7192 		// linear fit {{25.92, 0}, {50, 15.62}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.42,
				getRoyalty	: (price: number) => (0.643613 * price) - 16.3606 		// linear fit {{25.42, 0}, {50, 15.82}}
			},
			{
				market		: EnumMbaMarketplace.JP,
				priceMin	: 1,
				priceMax	: 9999,
				priceDefault: 3347,
				getRoyalty	: (price: number) => Math.round((0.56974 * price) - 1906.92) // linear fit {{3347, 0}, {8000, 2651}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 4050
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.AdultUnisex, EnumMbaFitType.Youth]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.HeatherGrey, EnumMbaColor.Navy, EnumMbaColor.Royal,
				EnumMbaColor.Asphalt, EnumMbaColor.Burgundy, EnumMbaColor.SageGreen, EnumMbaColor.KellyGreen, EnumMbaColor.Purple,
				EnumMbaColor.BrightPink, EnumMbaColor.DustyBlue, EnumMbaColor.DarkGreen, EnumMbaColor.Red, EnumMbaColor.Lemon,
				EnumMbaColor.White, EnumMbaColor.HeatherBlue, EnumMbaColor.LightBlue, EnumMbaColor.Pink
			],
			light 		: [
				EnumMbaColor.HeatherGrey, EnumMbaColor.BrightPink, EnumMbaColor.DustyBlue, EnumMbaColor.Lemon, EnumMbaColor.White,
				EnumMbaColor.LightBlue, EnumMbaColor.Pink
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.Navy, EnumMbaColor.Royal, EnumMbaColor.Asphalt, EnumMbaColor.Burgundy,
				EnumMbaColor.KellyGreen, EnumMbaColor.Purple, EnumMbaColor.DarkGreen, EnumMbaColor.Red, EnumMbaColor.SageGreen, EnumMbaColor.HeatherBlue
			],
			background	: false
		}
	},

	// Zip hoodie --------------------------
	{
		code			: EnumMbaProduct.ZipHoodie,
		name			: 'Zip Hoodie',
		nameShort		: 'Zip Hoodie',
		chartColor		: EnumColorName.Orangered,
		oldCode			: 'Zip hoodie',
		productorCode	: 'ZIP_HOODIE',
		keywords		: [
			'zip_hoodie', 'zip hoodie', 'zip', 'hoodie zip', 'hoodie_zip',
			'zip_hoodies', 'zip hoodies', 'zip', 'hoodies zip', 'hoodies_zip'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 26.99,
				getRoyalty	: (price: number) => (0.710455 * price) - 19.0473 		// linear fit {{26.81, 0}, {60, 23.58}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 23.06,
				getRoyalty	: (price: number) => (0.611668 * price) - 14.1051 		// linear fit {{23.06, 0}, {45, 13.42}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.86,
				getRoyalty	: (price: number) => (0.583264 * price) - 15.0832 		// linear fit {{25.86, 0}, {50, 14.08}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.28,
				getRoyalty	: (price: number) => (0.6339 * price) - 16.025 			// linear fit {{25.28, 0}, {50, 15.67}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.63,
				getRoyalty	: (price: number) => (0.618383 * price) - 15.8492 		// linear fit {{25.63, 0}, {50, 15.07}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.14,
				getRoyalty	: (price: number) => (0.615447 * price) - 15.4723 		// linear fit {{25.14, 0}, {50, 15.30}}
			},
			{
				market		: EnumMbaMarketplace.JP,
				priceMin	: 1,
				priceMax	: 9999,
				priceDefault: 3757,
				getRoyalty	: (price: number) => Math.round((0.743578 * price) - 2793.62)	// linear fit {{3757, 0}, {8000, 3155}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 4050
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.ForestGreen, EnumMbaColor.HeatherGrey,
				EnumMbaColor.Navy, EnumMbaColor.Purple, EnumMbaColor.Red, EnumMbaColor.Royal
			],
			light 		: [
				EnumMbaColor.HeatherGrey, EnumMbaColor.Purple
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.DarkHeather, EnumMbaColor.ForestGreen, EnumMbaColor.Navy, EnumMbaColor.Red, EnumMbaColor.Royal
			],
			background	: false
		}
	},

	// Performance hoodie -------------------
	{
		code			: EnumMbaProduct.PerformanceHoodie,
		name			: 'Performance Hoodie',
		nameShort		: 'Performance Hoodie',
		chartColor		: EnumColorName.Orangered,
		oldCode			: 'Performance Hoodie',
		productorCode	: 'PERFORMANCE_HOODIE',
		keywords		: [
			'performance_hoodie', 'performance hoodie', 'hoodie', 'performance', 'hoodies',
			'performance_hoodies', 'performance hoodies', 'hoodie', 'hoodies'

		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 37.99,
				getRoyalty: (price: number): number => (0.70 * price) - 23.133 // linear fit {{33.05, 0}, {36.99, 2.76}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 4050
			},
			{
				area	: EnumMbaPrint.Back,
				width 	: 4500,
				height	: 4050
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.White, EnumMbaColor.AsphaltGrey, EnumMbaColor.RoyalBlue,
				EnumMbaColor.NavyBlue
			],
			light 		: [
				EnumMbaColor.White, EnumMbaColor.AsphaltGrey, EnumMbaColor.RoyalBlue, EnumMbaColor.NavyBlue
			],
			dark 		: [
				EnumMbaColor.Black
			],
			background	: false
		}
	},

	// Performance Polo --------------------
	{
		code			: EnumMbaProduct.PerformancePolo,
		name			: 'Performance Polo',
		nameShort		: 'Performance Polo',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Performance polo',
		productorCode	: 'PERFORMANCE_POLO',
		keywords		: [
			'performance_polo', 'performance polo', 'polo', 'polo shirt', 'polo_tshirt',
			'polo_shirts', 'polo_tshirts', 'polo tee', 'polo_teeshirt', 'polo_tees'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 21.99,
				getRoyalty	: (price: number): number => (0.70 * price) - 11.683  // fit from {19.99,2.31}–{24.99,5.81}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: true,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Asphalt
			],
			light 		: [],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Asphalt
			],
			background	: false
		}
	},

	// Performance Quarter Zip -------------
	{
		code			: EnumMbaProduct.PerformanceQuarterZip,
		name			: 'Performance Quarter-Zip',
		nameShort		: 'Quarter-Zip',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Performance quarter-zip',
		productorCode	: 'PERFORMANCE_QUARTER_ZIP',
		keywords		: [
			'performance_quarter_zip', 'performance quarter zip', 'quarter zip', 'quarter_zip',
			'quarter_zips', 'quarter zip shirt', 'quarter_zip_shirt', 'quarter zip pullovers', 'quarter_zip_pullover'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 21.99,
				getRoyalty	: (price: number): number => (0.70 * price) - 12.393  // fit from {19.99,1.60}–{24.99,5.10}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4500,
				height	: 5400
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Men, EnumMbaFitType.Women]
		},
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy
			],
			light 		: [],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy
			],
			background	: false
		}
	},

	// Softshell Jacket --------------------
	{
		code			: EnumMbaProduct.SoftshellJacket,
		name			: 'Softshell Jacket',
		nameShort		: 'Softshell Jacket',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Softshell Jacket',
		productorCode	: 'SOFTSHELL_JACKET',
		keywords		: ['softshell_jacket', 'softshell jacket', 'softshell jackets', 'soft shell jacket', 'soft shell jackets'],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 44.99,
				// The {48.99, 4.12} Creator Tier example differs from this linear fit (4.19).
				getRoyalty	: (price: number): number => Math.round(((0.35 * price) - 12.9565) * 100) * 2 / 100 // linear fit {{44.99, 2.79}, {45.99, 3.14}, {46.99, 3.49}, {47.99, 3.84}}, royalties 2x
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width	: 1200,
				height	: 1200
			}
		],
		fitTypes		: {
			editable	: false,
			options		: [EnumMbaFitType.Men]
		},
		colors			: {
			all			: [EnumMbaColor.Black],
			light		: [],
			dark		: [EnumMbaColor.Black],
			background	: false
		}
	},

	// Baseball Hat ------------------------
	{
		code			: EnumMbaProduct.BaseballHat,
		name			: 'Baseball Hat',
		nameShort		: 'Baseball Hat',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Baseball Hat',
		productorCode	: 'BASEBALL_HAT',
		keywords		: [
			'baseball_hat', 'baseball hat', 'hat', 'baseball', 'cap',
			'baseball_hats', 'baseball hats', 'hats', 'baseballs', 'caps',
			'printed_baseball_hat', 'printed baseball hat', 'custom_baseball_hat', 'custom baseball hat'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty	: (price: number): number => (0.15 * price) - 0.0015  // fit from {19.99, 3.00}-{23.99, 3.60}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1500,
				height	: 675
			}
		],
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Red, EnumMbaColor.Royal, EnumMbaColor.LightBlue,
				EnumMbaColor.Slate, EnumMbaColor.White, EnumMbaColor.DarkGreen
			],
			light 		: [
				EnumMbaColor.LightBlue, EnumMbaColor.Slate, EnumMbaColor.White
			],
			dark 		: [
				EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Red, EnumMbaColor.Royal, EnumMbaColor.DarkGreen
			],
			background	: false
		}
	},

	// Trucker Hat --------------------
	{
		code			: EnumMbaProduct.TruckerHat,
		name			: 'Trucker Hat',
		nameShort		: 'Trucker Hat',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Trucker Hat',
		productorCode	: 'TRUCKER_HAT',
		keywords		: [
			'trucker_hat', 'trucker hat', 'hat', 'trucker', 'cap',
			'trucker_hats', 'trucker hats', 'hats', 'truckers', 'caps',
			'printed_trucker_hat', 'printed trucker hat', 'custom_trucker_hat', 'custom trucker hat'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 19.99,
				getRoyalty	: (price: number): number => (0.15 * price) - 0.0015  // fit from {19.99, 3.00}-{23.99, 3.60}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1500,
				height	: 675
			}
		],
		colors			: {
			all 		: [
				EnumMbaColor.Black, EnumMbaColor.BlackWhite, EnumMbaColor.Khaki, EnumMbaColor.KellyGreenWhite,
				EnumMbaColor.LightBlue, EnumMbaColor.Navy, EnumMbaColor.Pink, EnumMbaColor.Red, EnumMbaColor.RedWhiteRoyal,
				EnumMbaColor.White, EnumMbaColor.CamoGreen
			],
			light 		: [EnumMbaColor.BlackWhite, EnumMbaColor.Khaki, EnumMbaColor.KellyGreenWhite, EnumMbaColor.LightBlue, EnumMbaColor.Pink, EnumMbaColor.RedWhiteRoyal, EnumMbaColor.White],
			dark 		: [EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Red, EnumMbaColor.CamoGreen],
			background	: false
		}
	},

	// Sport Sun Visor ----------------------
	{
		code			: EnumMbaProduct.SportSunVisor,
		name			: 'Sport Sun Visor',
		nameShort		: 'Sun Visor',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Sport Sun Visor',
		productorCode	: 'SPORT_SUN_VISOR',
		keywords		: [
			'sport_sun_visor', 'sport sun visor', 'sport_sun_visors', 'sport sun visors', 'visor', 'visors',
			'sport_visor', 'sport visor', 'sun_visor', 'sun visor',
			'printed_sport_sun_visor', 'printed sport sun visor', 'custom_sport_sun_visor', 'custom sport sun visor'
		],
		productType		: EnumMbaProductType.Clothing,
		scalingType		: EnumMbaScalingType.Default,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 17.99,
				getRoyalty 	: (price: number): number => Math.round((0.2 * price + 0.002) * 100) / 100  // linear fit {{16.99, 2.55}, {17.99, 2.70}, {18.99, 2.85}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1500,
				height	: 675
			}
		],
		fitTypes: {
			editable	: true,
			options		: [EnumMbaFitType.Youth, EnumMbaFitType.AdultUnisex]
		},
		colors			: {
			all 		: [EnumMbaColor.Black, EnumMbaColor.White, EnumMbaColor.NavyBlue, EnumMbaColor.RoyalBlue, EnumMbaColor.Red, EnumMbaColor.Pink, EnumMbaColor.Purple],
			light 		: [EnumMbaColor.White],
			dark 		: [EnumMbaColor.Black, EnumMbaColor.NavyBlue, EnumMbaColor.RoyalBlue, EnumMbaColor.Red, EnumMbaColor.Pink, EnumMbaColor.Purple],
			background	: false
		}
	},

	// Sport Backpack -------------------------
	{
		code			: EnumMbaProduct.SportBackpack,
		name			: 'Sport Backpack',
		nameShort		: 'Sport Backpack',
		chartColor		: EnumColorName.Darkred,
		oldCode			: 'Sport Backpack',
		productorCode	: 'SPORT_BACKPACK',
		keywords		: [
			'sport_backpack', 'sport backpack', 'sport_backpacks', 'sport backpacks', 'backpack', 'backpacks'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 42.99,
				getRoyalty   : (price: number): number => Math.round((0.14 * price - 0.0186) * 100) / 100  // linear fit {{42.99, 6.00}, {43.99, 6.14}, {44.99, 6.28}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.FrontPanel,
				width 	: 1800,
				height	: 2400
			},
			{
				area	: EnumMbaPrint.FrontPocket,
				width 	: 1800,
				height	: 2400
			}
		],
		colors			: {
			all 		: [EnumMbaColor.Black],
			light 		: [],
			dark 		: [EnumMbaColor.Black],
			background	: false
		}
	},

	// PopSockets Grip ---------------------
	{
		code			: EnumMbaProduct.PopSockets,
		name			: 'PopSockets Grip',
		nameShort		: 'PopSockets Grip',
		chartColor		: EnumColorName.Purple,
		oldCode			: 'PopSockets grip',
		productorCode	: 'POP_SOCKET',
		keywords		: [
			'popsockets', 'popsockets grip', 'pop_socket', 'popsocket', 'pop-socket', 'socket', 'phone socket', 'phone_socket',
			'pop sockets grip', 'sockets grip', 'pop-sockets grip', 'pop_sockets_grip'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 11.72,
				getRoyalty	: (price: number) => (0.140232 * price) - 0.00304037 	// linear fit {{11.72, 1.64}, {15.85, 2.22}, {18.55, 2.60}, {20, 2.80}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 9.68,
				getRoyalty	: (price: number) => (0.116412 * price) - 0.00294493 	// linear fit {{9.68, 1.13}, {15.88, 1.85}, {18.25, 2.13}, {20, 2.33}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 10.34,
				getRoyalty	: (price: number) => (0.11792 * price) - 0.00502856 	// linear fit {{11.25, 1.32}, {15.63, 1.84}, {18.25, 2.15}, {20, 2.35}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.29,
				getRoyalty	: (price: number) => (0.116917 * price) - 0.00504976 	// linear fit {{12.29, 1.43}, {16.86, 1.97}, {18.25, 2.13}, {20, 2.33}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 12.28,
				getRoyalty	: (price: number) => (0.114019 * price) - 0.0103138 	// linear fit {{12.28, 1.41}, {13.25, 1.52}, {15.85, 1.82}, {17.36, 1.99}, {19.21, 2.20}, {20, 2.29}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 11.86,
				getRoyalty	: (price: number) => 0.115686 * price - 0.00214442 		// linear fit {{11.86, 1.37}, {13.25, 1.53}, {15.85, 1.83}, {17.36, 2.01}, {19.21, 2.22}, {20, 2.31}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 485,
				height	: 485
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true
		}
	},

	// iPhone cases ------------------------
	{
		code			: EnumMbaProduct.IPhoneCases,
		name			: 'iPhone Phone Cases',
		nameShort		: 'iPhone Cases',
		chartColor		: EnumColorName.Lightcyan,
		oldCode			: 'iPhone cases',
		productorCode	: 'PHONE_CASE_APPLE_IPHONE',
		keywords		: [
			'iphone_cases', 'apple iphone phone cases', 'apple_iphone_phone_cases', 'apple iphone cases', 'apple_iphone_cases',
			'apple phone case', 'apple case', 'apple phone', 'apple_phone_case', 'phone_case_apple_iphone'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.84,
				getRoyalty	: (price: number) => (0.696163 * price) - 9.6349 	// linear fit {{13.84, 0}, {30, 11.25}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.99,
				getRoyalty	: (price: number) => (0.125 * price) + 0.00125 		// linear fit {{13.99, 1.75}, {17.99, 2.25}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 14.99,
				getRoyalty	: (price: number) => (0.126 * price) + 0.00126 		// linear fit {{14.99, 1.89}, {19.99, 2.52}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.99,
				getRoyalty	: (price: number) => (0.125 * price) + 0.00125 		// linear fit {{15.99, 2.00}, {19.99, 2.50}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.99,
				getRoyalty	: (price: number) => (0.1225 * price) + 0.011225 	// linear fit {{15.99, 1.97}, {19.99, 2.46}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.99,
				getRoyalty	: (price: number) => (0.125 * price) - 0.01875 		// linear fit {{15.99, 1.98}, {19.99, 2.48}}
			},
			{
				market		: EnumMbaMarketplace.JP,
				priceMin	: 1,
				priceMax	: 9999,
				priceDefault: 1618,
				getRoyalty	: (price: number) => Math.round((0.714052 * price) - 1155.34) // linear fit {{1618, 0}, {6500, 3486}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1800,
				height	: 3200
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true
		}
	},

	// Samsung cases -----------------------
	{
		code			: EnumMbaProduct.SamsungCases,
		name			: 'Samsung Phone Cases',
		nameShort		: 'Samsung Cases',
		chartColor		: EnumColorName.Cyan,
		oldCode			: 'Samsung cases',
		productorCode	: 'PHONE_CASE_SAMSUNG_GALAXY',
		keywords		: [
			'samsung_cases', 'samsung galaxy phone cases', 'samsung_galaxy_phone_cases', 'samsung galaxy cases',
			'samsung_galaxy_cases', 'phone_case_samsung_galaxy', 'galaxy cases', 'samsung cases'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.84,
				getRoyalty	: (price: number) => (0.696163 * price) - 9.6349 	// linear fit {{13.84, 0}, {30, 11.25}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.99,
				getRoyalty	: (price: number) => (0.125 * price) + 0.00125 		// linear fit {{13.99, 1.75}, {17.99, 2.25}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 14.99,
				getRoyalty	: (price: number) => (0.126 * price) + 0.00126 		// linear fit {{14.99, 1.89}, {19.99, 2.52}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.99,
				getRoyalty	: (price: number) => (0.125 * price) + 0.00125 		// linear fit {{15.99, 2.00}, {19.99, 2.50}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.99,
				getRoyalty	: (price: number) => (0.1225 * price) + 0.011225 	// linear fit {{15.99, 1.97}, {19.99, 2.46}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.99,
				getRoyalty	: (price: number) => (0.125 * price) - 0.01875 		// linear fit {{15.99, 1.98}, {19.99, 2.48}}
			},
			{
				market		: EnumMbaMarketplace.JP,
				priceMin	: 1,
				priceMax	: 9999,
				priceDefault: 1618,
				getRoyalty	: (price: number) => Math.round((0.714052 * price) - 1155.34) // linear fit {{1618, 0}, {6500, 3486}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1800,
				height	: 3200
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true
		}
	},

	// Tote bag ----------------------------
	{
		code			: EnumMbaProduct.ToteBag,
		name			: 'Tote Bag',
		nameShort		: 'Tote Bag',
		chartColor		: EnumColorName.Darkgreen,
		oldCode			: 'Tote bag',
		productorCode	: 'TOTE_BAG',
		keywords		: [
			'tote_bag', 'tote bag', 'tote bags', 'bag', 'tote',
			'tote_bags', 'tote bags', 'tot bags', 'bags', 'totes'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 15.54,
				getRoyalty	: (price: number) => (0.82981 * price) - 12.8952 	// linear fit {{15.54, 0}, {25, 7.85}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 2925,
				height	: 2925
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true
		}
	},

	// Crossbody bag -----------------------
	{
		code			: EnumMbaProduct.CrossbodyBag,
		name			: 'Crossbody Bag',
		nameShort		: 'Crossbody Bag',
		chartColor		: EnumColorName.Darkgreen,
		oldCode			: 'Crossbody Bag',
		productorCode	: 'CROSSBODY_BAG',
		keywords		: [
			'crossbody_bag', 'crossbody bag', 'crossbody_bags', 'crossbody bags', 'cross body bag', 'cross body bags'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 24.99,
				getRoyalty	: (price: number): number => Math.round(((0.07 * price) - 0.0093) * 100) * 2 / 100 // linear fit {{24.99, 3.48}, {25.99, 3.62}, {26.99, 3.76}, {27.99, 3.90}, {28.99, 4.04}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1200,
				height	: 750
			}
		],
		colors			: {
			all			: [EnumMbaColor.Black, EnumMbaColor.Stone],
			light		: [EnumMbaColor.Stone],
			dark		: [EnumMbaColor.Black],
			background	: false
		}
	},

	// Laptop Sleeve -------------------------
	{
		code			: EnumMbaProduct.LaptopSleeve,
		name			: 'Laptop Sleeve',
		nameShort		: 'Laptop Sleeve',
		chartColor		: EnumColorName.Darkblue,
		oldCode			: 'Laptop Sleeve',
		productorCode	: 'LAPTOP_SLEEVE',
		keywords		: [
			'laptop_sleeve', 'laptop sleeve', 'laptop_sleeves', 'laptop sleeves', 'notebook sleeve', 'computer sleeve'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 25.99,
				getRoyalty 	: (price: number): number => (0.07 * price) + 0.0007 // linear fit {{25.99, 1.82}, {26.99, 1.89}, {27.99, 1.96}, {28.99, 2.03}, {29.99, 2.10}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 2325,
				height	: 1800
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true,
			defaultBackground: '#FFFFFF'
		}
	},

	// Mouse Pad -----------------------------
	{
		code			: EnumMbaProduct.MousePad,
		name			: 'Mouse Pad',
		nameShort		: 'Mouse Pad',
		chartColor		: EnumColorName.Blue,
		oldCode			: 'Mouse Pad',
		productorCode	: 'MOUSE_PAD',
		keywords		: [
			'mouse_pad', 'mouse pad', 'mouse_pads', 'mouse pads', 'mousepad', 'mousepads', 'desk mat', 'desk pad'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.99,
				getRoyalty 	: (price: number): number => (0.07 * price) + 0.0007 // linear fit {{13.99, 0.98}, {14.99, 1.05}, {15.99, 1.12}, {16.99, 1.19}, {17.99, 1.26}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 2700,
				height	: 2250
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true,
			defaultBackground: '#FFFFFF'
		}
	},

	// Throw pillows -----------------------
	{
		code			: EnumMbaProduct.ThrowPillows,
		name			: 'Throw Pillows',
		nameShort		: 'Throw Pillows',
		chartColor		: EnumColorName.Darkred,
		oldCode			: 'Throw pillows',
		productorCode	: 'THROW_PILLOW',
		keywords		: [
			'throw_pillows', 'throw pillows', 'throw_pillow', 'throw pillow', 'throw pillows'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 17.39,
				getRoyalty	: (price: number) => (0.80623 * price) - 14.0203 	// linear fit {{17.39, 0}, {45, 22.26}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 2925,
				height	: 2925
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true
		}
	},

	// Throw Blanket -------------------------
	{
		code			: EnumMbaProduct.ThrowBlanket,
		name			: 'Throw Blanket',
		nameShort		: 'Throw Blanket',
		chartColor		: EnumColorName.Purple,
		oldCode			: 'Throw Blanket',
		productorCode	: 'THROW_BLANKET',
		keywords		: [
			'throw_blanket', 'throw blanket', 'throw_blankets', 'throw blankets', 'graphic throw blanket', 'blanket', 'blankets'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 28.99,
				getRoyalty 	: (price: number): number => (0.07 * price) + 0.0007 // linear fit {{28.99, 2.03}, {29.99, 2.10}, {30.99, 2.17}, {31.99, 2.24}, {32.99, 2.31}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 7950,
				height	: 9450
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true,
			defaultBackground: '#FFFFFF'
		}
	},

	// Unframed Poster ------------------------
	{
		code			: EnumMbaProduct.UnframedPoster,
		name			: 'Unframed Poster',
		nameShort		: 'Unframed Poster',
		chartColor		: EnumColorName.Green,
		oldCode			: 'Unframed Poster',
		productorCode	: 'MATTE_POSTER',
		keywords		: [
			'unframed_poster', 'unframed poster', 'unframed_posters', 'unframed posters', 'matte_poster', 'matte poster', 'poster', 'posters'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 11.99,
				getRoyalty 	: (price: number): number => (0.07 * price) + 0.0007 // linear fit {{11.99, 0.84}, {12.99, 0.91}, {13.99, 0.98}, {14.99, 1.05}, {15.99, 1.12}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 4800,
				height	: 6000
			}
		],
		colors			: {
			all 		: [],
			light 		: [],
			dark 		: [],
			background	: true,
			defaultBackground: '#FFFFFF'
		}
	},

	// Tumbler -----------------------------
	{
		code			: EnumMbaProduct.Tumbler,
		name			: 'Tumbler',
		nameShort		: 'Tumbler',
		chartColor		: EnumColorName.Darkred,
		oldCode			: 'Tumbler',
		productorCode	: 'TUMBLER',
		keywords		: [
			'tumbler', 'tumbler', 'tumblers', 'tumbler'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.14 * price) + 0.0014 	// linear fit {{20.99, 2.94}, {21.99, 3.08}, {22.99, 3.22}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.124 * price) + 0.02024 	// linear fit {{19.99, 2.50}, {20.99, 2.62}, {21.99, 2.75}, {22.99, 2.87}}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.126 * price) + 0.00226 	// linear fit {{19.99, 2.52}, {20.99, 2.65}, {21.99, 2.77}, {22.99, 2.90}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.124 * price) + 0.02024 	// linear fit {{19.99, 2.50}, {20.99, 2.62}, {21.99, 2.75}, {22.99, 2.87}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.123 * price) + 0.00077 	// linear fit {{19.99, 2.46}, {20.99, 2.58}, {21.99, 2.70}, {22.99, 2.83}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 20.99,
				getRoyalty	: (price: number) => (0.124 * price) + 0.00024 	// linear fit {{19.99, 2.48}, {20.99, 2.60}, {21.99, 2.73}, {22.99, 2.85}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1800,
				height	: 2400
			}
		],
		colors			: {
			all 		: [EnumMbaColor.Black, EnumMbaColor.BrushedSteel, EnumMbaColor.White,
				EnumMbaColor.Pink, EnumMbaColor.Lilac, EnumMbaColor.LightBlue, EnumMbaColor.Royal, EnumMbaColor.Red, EnumMbaColor.DarkGreen],
			light 		: [EnumMbaColor.White, EnumMbaColor.BrushedSteel, EnumMbaColor.Pink, EnumMbaColor.Lilac, EnumMbaColor.LightBlue],
			dark 		: [EnumMbaColor.Black, EnumMbaColor.Royal, EnumMbaColor.Red, EnumMbaColor.DarkGreen],
			background	: false
		}
	},

	// Travel Tumbler -------------------------
	{
		code			: EnumMbaProduct.TravelTumbler,
		name			: 'Stainless Steel Travel Tumbler',
		nameShort		: 'Travel Tumbler',
		chartColor		: EnumColorName.Cyan,
		oldCode			: 'Travel Tumbler',
		productorCode	: 'TRAVEL_TUMBLER',
		keywords		: [
			'travel_tumbler', 'travel tumbler', 'travel_tumblers', 'travel tumblers', 'stainless steel travel tumbler', 'travel mug'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 29.99,
				getRoyalty 	: (price: number): number => (0.075 * price) - 0.00125 // linear fit {{29.99, 2.25}, {30.99, 2.32}, {31.99, 2.40}, {32.99, 2.47}, {33.99, 2.55}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 3213,
				height	: 1571
			}
		],
		colors			: {
			all 		: [EnumMbaColor.White],
			light 		: [EnumMbaColor.White],
			dark 		: [],
			background	: false
		}
	},

	// Ceramic Mug -------------------------
	{
		code			: EnumMbaProduct.CeramicMug,
		name			: 'Ceramic Mug',
		nameShort		: 'Ceramic Mug',
		chartColor		: EnumColorName.Darkred,
		oldCode			: 'Ceramic Mug',
		productorCode	: 'CERAMIC_MUG',
		keywords		: [
			'ceramic_mug', 'ceramic mug', 'ceramic_mugs', 'ceramic mugs', 'mug', 'mugs'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 16.99,
				getRoyalty 	: (price: number): number => Math.round((0.15 * price + 0.0015) * 100) / 100  // linear fit {{16.99, 2.55}, {17.99, 2.70}, {18.99, 2.85}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1800,
				height	: 2400
			}
		],
		colors			: {
			all 		: [EnumMbaColor.White, EnumMbaColor.BlackWhite, EnumMbaColor.BlueWhite,
				EnumMbaColor.RedWhite, EnumMbaColor.PinkWhite, EnumMbaColor.YellowWhite,
				EnumMbaColor.OrangeWhite, EnumMbaColor.DarkBlueWhite, EnumMbaColor.DarkGreenWhite, EnumMbaColor.GreenWhite],
			light 		: [EnumMbaColor.White, EnumMbaColor.BlackWhite, EnumMbaColor.BlueWhite,
				EnumMbaColor.RedWhite, EnumMbaColor.PinkWhite, EnumMbaColor.YellowWhite,
				EnumMbaColor.OrangeWhite, EnumMbaColor.DarkBlueWhite, EnumMbaColor.DarkGreenWhite, EnumMbaColor.GreenWhite],
			dark 		: [],
			background	: false
		}
	},

	// Water Bottle -------------------------
	{
		code			: EnumMbaProduct.WaterBottle,
		name			: 'Water Bottle',
		nameShort		: 'Water Bottle',
		chartColor		: EnumColorName.Darkred,
		oldCode			: 'Water Bottle',
		productorCode	: 'WATER_BOTTLE',
		keywords		: [
			'water_bottle', 'water bottle', 'water_bottles', 'water bottles', 'bottle', 'bottles'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 28.99,
				getRoyalty 	: (price: number): number => Math.round((0.15 * price + 0.0015) * 100) / 100  // linear fit {{25.99, 3.90}, {26.99, 4.05}, {27.99, 4.20}, {28.99, 4.35}}
			},
			{
				market		: EnumMbaMarketplace.CO_UK,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 18.99,
				getRoyalty 	: (price: number): number => Math.round((0.126 * price - 0.02174) * 100) / 100  // linear fit for: {18.99->2.37, 19.99->2.50, 20.99->2.62, 21.99->2.75}
			},
			{
				market		: EnumMbaMarketplace.DE,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 22.99,
				getRoyalty: (price: number): number => (0.125 * price) + 0.025  // linear fit {{20.99, 2.65}, {22.99, 2.90}}
			},
			{
				market		: EnumMbaMarketplace.FR,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 22.99,
				getRoyalty: (price: number): number => (0.125 * price) - 0.002  // linear fit {{20.99, 2.62}, {22.99, 2.87}}
			},
			{
				market		: EnumMbaMarketplace.IT,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 22.99,
				getRoyalty: (price: number): number => (0.125 * price) - 0.045  // linear fit {{20.99, 2.58}, {22.99, 2.83}}
			},
			{
				market		: EnumMbaMarketplace.ES,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 22.99,
				getRoyalty: (price: number): number => (0.125 * price) - 0.022  // linear fit {{20.99, 2.60}, {22.99, 2.85}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1800,
				height	: 2400
			}
		],
		colors			: {
			all 		: [EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Red, EnumMbaColor.Royal, EnumMbaColor.LightBlue, EnumMbaColor.White, EnumMbaColor.DarkGreen],
			light 		: [EnumMbaColor.LightBlue, EnumMbaColor.White],
			dark 		: [EnumMbaColor.Black, EnumMbaColor.Navy, EnumMbaColor.Red, EnumMbaColor.Royal, EnumMbaColor.DarkGreen],
			background	: false
		}
	},

	// Handcover Journal -------------------------
	{
		code			: EnumMbaProduct.HardcoverJournal,
		name			: 'Hardcover Journal',
		nameShort		: 'Hardcover Journal',
		chartColor		: EnumColorName.Darkred,
		oldCode			: 'Hardcover Journal',
		productorCode	: 'HARDCOVER_JOURNAL',
		keywords		: [
			'hardcover_journal', 'hardcover journal', 'hardcover_journals', 'hardcover journals', 'journal', 'journals'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 16.99,
				getRoyalty  : (price: number): number => Math.round((0.15 * price + 0.0015) * 100) / 100  // linear fit {{15.99, 2.40}, {16.99, 2.55}, {17.99, 2.70}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 1800,
				height	: 2400
			}
		],
		colors			: {
			all 		: [EnumMbaColor.Black],
			light 		: [],
			dark 		: [EnumMbaColor.Black],
			background	: false
		}
	},

	// Retractable Pens -----------------------
	{
		code			: EnumMbaProduct.RetractablePen,
		name			: '12-Pack Retractable Pens',
		nameShort		: 'Retractable Pens',
		chartColor		: EnumColorName.Red,
		oldCode			: 'Retractable Pen',
		productorCode	: 'RETRACTABLE_PEN',
		keywords		: [
			'retractable_pen', 'retractable pen', 'retractable_pens', 'retractable pens', '12-pack retractable pens', 'pen', 'pens'
		],
		productType		: EnumMbaProductType.Accessory,
		scalingType		: EnumMbaScalingType.Special,
		marketplaces 	: [
			{
				market		: EnumMbaMarketplace.COM,
				priceMin	: 1,
				priceMax	: 999,
				priceDefault: 13.99,
				getRoyalty 	: (price: number): number => (0.07 * price) - 0.0093 // linear fit {{13.99, 0.97}, {14.99, 1.04}, {15.99, 1.11}, {16.99, 1.18}, {17.99, 1.25}}
			}
		],
		printAreas		: [
			{
				area	: EnumMbaPrint.Front,
				width 	: 850,
				height	: 75
			}
		],
		colors			: {
			all 		: [EnumMbaColor.Black, EnumMbaColor.MultiColor],
			light 		: [],
			dark 		: [EnumMbaColor.Black, EnumMbaColor.MultiColor],
			background	: false
		}
	}
];


/**------------------------------------------------------
 * Interface Definitions
 */
export interface IAmazonMbaProduct {
	code			: EnumMbaProduct;
	name			: string;
	nameShort		: string;
	chartColor		: EnumColorName;
	oldCode			: string;					// used for the import from Flying Upload v1.0
	productorCode	: string;
	keywords		: string[];					// used for the excel import, to map the user input to the product
	productType		: EnumMbaProductType;
	scalingType		: EnumMbaScalingType;
	marketplaces 	: IAmazonMbaMarketplace[];
	printAreas		: IAmazonMbaPrint[];
	fitTypes	   ?: IAmazonMbaFitTypes;		// not needed for none clothing products
	colors			: IColors;
}

export interface IAmazonMbaMarketplace {
	market		: EnumMbaMarketplace;
	priceMin	: number;
	priceMax	: number;
	priceDefault: number;	// default price suggested to the user
	getRoyalty	: (number: number) => number;	// calculation of the royalty
}

export interface IAmazonMbaPrint {
	area		: EnumMbaPrint;					// example: front
	width		: number;						// example: 5400 pixel
	height		: number;						// example: 4500 pixel
}

export interface IAmazonMbaFitTypes {
	editable	: boolean;
	options		: EnumMbaFitType[];
}

export interface IColors {
	all 		: EnumMbaColor[];
	light 		: EnumMbaColor[];
	dark 		: EnumMbaColor[];
	background	: boolean;
	defaultBackground?: string;	// Optional product-specific default for new and legacy listings.
}
